const enterAR = () => {
    // starts A-Frames AR session
    document.querySelector('a-scene').enterAR();
};

function arButton() {
    const arButton = document.getElementById('enter-ar');

    if (navigator.xr) {
        navigator.xr.isSessionSupported('immersive-ar').then((isSupported) => {
            if (isSupported) {
                arButton.addEventListener('click', enterAR);
            } else {
                arButton.textContent = 'AR wird nicht unterstützt.';
                arButton.disabled = true;
            }
        });
    } else {
        arButton.textContent = 'Bitte nutzen sie Google Chrome.';
        arButton.disabled = true;
    }
}

module.exports = arButton;
